import { render } from "./CodeColorLegend.vue?vue&type=template&id=6faed55e&scoped=true"
import script from "./CodeColorLegend.vue?vue&type=script&lang=js"
export * from "./CodeColorLegend.vue?vue&type=script&lang=js"

import "./CodeColorLegend.vue?vue&type=style&index=0&id=6faed55e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6faed55e"]])

export default __exports__